import axios from "axios";

const API_URL = process.env.REACT_APP_HOST_API;

class ReportService {

    async getRelatorioOrdems(inicio, fim) {

        var url;

        if (!inicio || !fim) {
            url = `${API_URL}/v1/report/ordems`;
        } else {
            url = `${API_URL}/v1/report/ordems?inicio=${inicio}&fim=${fim}`;
        }
        return axios.get(url, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorizationWGSolJwtToken"),
            },
        });
    }

    async getIndicadores(inicio, fim) {

        var url;

        if (!inicio || !fim) {
            url = `${API_URL}/v1/report/indicadores`;
        } else {
            url = `${API_URL}/v1/report/indicadores?inicio=${inicio}&fim=${fim}`;
        }
        
        return axios.get(url, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorizationWGSolJwtToken"),
            },
        });
    }

    async getRelatorioAtendimentoEquipe(idEquipe, inicio, fim) {
        var url = `${API_URL}/v1/report/atendimento-equipe`;
        
        const params = new URLSearchParams();
        if (idEquipe) params.append('idEquipe', idEquipe);
        if (inicio) params.append('inicio', inicio);
        if (fim) params.append('fim', fim);
        
        if (params.toString()) {
            url += '?' + params.toString();
        }
        
        return axios.get(url, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorizationWGSolJwtToken"),
            },
        });
    }

    formatarMoeda(valor) {
        if (!valor) return "R$ 0,00";
        return new Intl.NumberFormat('pt-BR', { 
            style: 'currency', 
            currency: 'BRL' 
        }).format(valor);
    }

    formatarPercentual(valor) {
        if (!valor) return "0%";
        return (Math.round(valor * 100) / 100).toFixed(2) + "%";
    }

    formatarData(data) {
        if (!data) return "-";
        
        // Se já é uma string formatada (ex: "31/08/2026"), retorna como está
        if (typeof data === 'string' && data.includes('/')) {
            return data;
        }
        
        // Se for string ISO sem hora (ex: "2026-08-09"), adiciona hora para evitar timezone issues
        if (typeof data === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(data)) {
            const [ano, mes, dia] = data.split('-');
            return `${dia}/${mes}/${ano}`;
        }
        
        // Caso contrário, converte de Date ou timestamp ISO completo
        try {
            const date = typeof data === 'string' ? new Date(data + 'T00:00:00') : new Date(data);
            if (isNaN(date.getTime())) return "-";
            return date.toLocaleDateString('pt-BR');
        } catch (e) {
            return "-";
        }
    }
}

export default new ReportService();
